import styled from 'styled-components';
import { color, typography } from 'styles/settings';
import { ReactComponent as Notification } from 'styles/icons/notification.svg';

export const Container = styled.div`
  cursor: pointer;
`;

export const Count = styled.span`
  cursor: pointer;
  position: absolute;
  top: 6px;
  left: 39px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 19px;
  height: 19px;
  background: #dcaa4e 0% 0% no-repeat padding-box;
  border: 2px solid #ffffff;
  border-radius: 60px;
  color: #1c1b18;
  font-size: 16px;
  line-height: 21px;
  ${typography.font.title};
`;

export const Icon = styled(Notification)`
  cursor: pointer;
  color: ${color.brand.blueDark};

  :hover {
    color: ${color.brand.gold};
  }
  :active {
    color: ${color.brand.blueDark};
  }
`;
